"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TriggerType;
(function (TriggerType) {
    TriggerType["AdHocLocation"] = "AdHocLocation";
    TriggerType["SendKitResult"] = "SendKitResult";
})(TriggerType = exports.TriggerType || (exports.TriggerType = {}));
//# sourceMappingURL=TriggerType.js.map